import { copy } from '@/copy'

/** A list that could not be loaded: what failed, and Try again. */
export function Failed({ what, onRetry, busy }: { what: string; onRetry: () => void; busy?: boolean }) {
  return (
    <div className="card flex flex-wrap items-center justify-between gap-4 p-6">
      <p className="m-0 font-medium">{what}</p>
      <button type="button" className="action" onClick={onRetry} aria-disabled={busy || undefined}>
        {copy.tryAgain}
      </button>
    </div>
  )
}

/** A placeholder while the first answer is on its way: the list's card, a row high per row. */
export function Loading({ rows = 2 }: { rows?: number }) {
  return <div className="card opacity-60" style={{ height: rows * 64 }} aria-hidden="true" />
}
